import React, { useState } from "react";
import { Tooltip } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { ReactComponent as InfoIcon } from "../../../../../../assets/icons/info.svg";

import "./NewMemberTooltip.scss";

const NewMemberTooltip = ({ icon = <InfoIcon />, title = "", summary, details = [] }) => {
   const [expanded, setExpanded] = useState(false);

   const toggleExpanded = (e) => {
      e.stopPropagation();
      setExpanded((prev) => !prev);
   };

   const tooltipContent = (
      <div className="new-member__tooltip-content" onClick={(e) => e.stopPropagation()}>
         {title && <h3>{title}</h3>}
         <hr />
         {summary && <span>{summary}</span>}
         {expanded &&
            details.map((item, index) => (
               <span key={index}>
                  <b>{item.label}: </b>
                  {item.text}
                  <br />
               </span>
            ))}
         {details.length > 0 && (
            <span className="new-member__toggle" onClick={toggleExpanded}>
               {expanded ? (
                  <>
                     Show less <UpOutlined />
                  </>
               ) : (
                  <>
                     Show more <DownOutlined />
                  </>
               )}
            </span>
         )}
      </div>
   );

   return (
      <Tooltip
         title={tooltipContent}
         placement="bottom"
         color="#5770CB"
         overlayClassName="new-member__tooltip"
         trigger={["hover"]}
      >
         {icon}
      </Tooltip>
   );
};

export default NewMemberTooltip;
